import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { routesNames } from '../../utils/constants';
import { useStyles } from './breadCrumbs.styles';

export const BreadCrumbs = (): JSX.Element => {
  const opportunities = useAppSelector((state) => state.organizerReducer.opportunitiesById);
  const tab = useAppSelector((state) => state.organizerReducer.tabs);
  const classes = useStyles();
  const category = tab === 0 ? 'Current' : tab === 1 ? 'Completed' : 'All';

  return (
    <Breadcrumbs className={classes.breadCrumbs} aria-label="breadcrumb">
      <Link
        underline="hover"
        color="inherit"
        to="/"
        component={RouterLink}
      >
        My opportunities
      </Link>
      <Link
        underline="hover"
        color="inherit"
        to={routesNames.main}
        component={RouterLink}
      >
        {category}
      </Link>
      <Typography color="#3B5D3E">{opportunities && opportunities.name}</Typography>
    </Breadcrumbs>
  );
};
